export const countryCurrencyMap: Record<string, string> = {
  AU: 'AUD',
  CA: 'CAD',
  CH: 'CHF',
  DK: 'DKK',
  GB: 'GBP',
  NO: 'NOK',
  NZ: 'NZD',
  SE: 'SEK',
  US: 'USD'
};

export const DEFAULT_CURRENCY = 'EUR';

// countryCurrencyMap keys plus NL (falls back to EUR) so nl-NL has a matching region.
export const PREFERENCE_COUNTRIES = [...Object.keys(countryCurrencyMap), 'NL'].sort();
